import React, { ReactNode } from 'react';
import {
  ThemeProvider as BiomeThemeProvider,
  theme as biomeTheme
} from '@biome-design-system/styles';
import { createHSTheme } from '@biome-design-system/hs-utils';
import { fromTheme } from '@kyruus/ui-theme';
import { PMCConfig } from '@kyruus/types';
import { getCustomerKyruusTheme } from './utils';

interface ThemeProviderProps {
  customerConfig?: PMCConfig;
  children: ReactNode;
  isCancelOrManageApptFlow?: boolean;
}

export const ThemeProvider = ({
  customerConfig,
  children,
  isCancelOrManageApptFlow = false
}: ThemeProviderProps) => {
  const customerKyruusTheme = getCustomerKyruusTheme({
    customerConfig,
    isCancelOrManageApptFlow
  });
  const customerBiomeTheme = createHSTheme(
    biomeTheme,
    customerKyruusTheme,
    fromTheme
  );
  return (
    <BiomeThemeProvider
      theme={{ ...customerBiomeTheme, ...customerKyruusTheme }}
    >
      {children}
    </BiomeThemeProvider>
  );
};
